import React from 'react';
import { useHistory } from 'react-router-dom';
import Modal2 from 'components/_shared/Modal2';
import MemberStatus from './components/MemberStatus';
import MemberDetails from 'components/holders_list/components/EligibilityComponents/MemberDetails';
import { CTAButton3 } from 'components/_shared/buttons';
import Button from '@mui/material/Button';
import { makeStyles } from '@mui/styles';
import { MemberSearchResult } from 'types/index';

const useStyles = makeStyles(() => ({
    body: {
        display: 'flex',
        flexDirection: 'column',
        gap: '16px',
        padding: '32px'
    },
    buttonContainer: {
        display: 'flex',
        flexDirection: 'column',
        gap: '16px',
        marginTop: '40px'
    },
    closeButton: {
        color: '#7378E8',
        fontSize: '14px',
        fontWeight: '600',
        textTransform: 'none !important'
    },
    btnDiv: {
        display: 'flex',
        justifyContent: 'center'
    }
}));

const iconStyle = {
    backgroundColor: '#E7EFFE',
    border: '2px solid #062D7A',
    color: '#062D7A',
    fontSize: '24px'
};

type ExistingMemberProps = {
    member: MemberSearchResult;
    closeButtonText: string;
    handleCloseClick: () => void;
};

const ExistingMember: React.FC<ExistingMemberProps> = ({
    member,
    closeButtonText,
    handleCloseClick
}) => {
    const classes = useStyles();
    const history = useHistory();

    const handleViewProfile = () => {
        handleCloseClick();
        history.push(`/holders/${member.id}`);
    };

    return (
        <Modal2
            onClose={handleCloseClick}
            additionalStyles={{ iconStyle: iconStyle }}
            iconName=""
            title="Existing Member"
        >
            <div className={classes.body}>
                <MemberStatus
                    photo={member.photo}
                    icon="far fa-check"
                    title={`${member.name} has an active membership!`}
                    subtext={``}
                    colorType="green"
                />
                <MemberDetails member={member} />
                <div className={classes.buttonContainer}>
                    <CTAButton3 onClick={handleViewProfile}>
                        View Profile
                    </CTAButton3>
                </div>
                <div className={classes.btnDiv}>
                    <Button className={classes.closeButton} onClick={handleCloseClick}>
                        {closeButtonText}
                    </Button>
                </div>
            </div>
        </Modal2>
    );
};

export default ExistingMember;
